import {
  isExternalMedia,
  isExternalMediaWeblink,
  isMedialinkStudentAssignment,
  isMiniSite,
  Medialink,
} from '../modules/material/_api/MedialinksApi';

export function getLinkFromMedialink(medialink: Medialink) {
  if (isMiniSite(medialink) && medialink.miniSite?.target === 'new-window') {
    return medialink.miniSite.href;
  }

  if (
    isExternalMedia(medialink) &&
    isExternalMediaWeblink(medialink) &&
    medialink.externalMedia.target === 'new-window'
  ) {
    return medialink.externalMedia.href;
  }

  return;
}

export function validateAndGetLinkFromMedialink(medialink: Medialink) {
  if (isMedialinkStudentAssignment(medialink)) return undefined;

  return getLinkFromMedialink(medialink);
}

export const EXERCISE_KINDS = ['exercise-edumatic', 'exercise-eduhint', 'exercise-assessmentq'];

/**
 * @deprecated use isScorableMedialink from api instead
 */
export function checkIsExercise(kind: string) {
  return EXERCISE_KINDS.includes(kind);
}
